'use client';

import { useEffect } from 'react';
import { trackEvent } from '../../_lib/segment';
import { convertObjectValuesToTitleCase } from '../../_lib/segment/utils';
import type { ExperimentTrackerProps } from './types';

export const ExperimentTracker = ({
  flagName,
  variationKey,
  ruleKey,
  pageConfig,
}: ExperimentTrackerProps) => {
  useEffect(() => {
    if (!flagName || !variationKey || !ruleKey) return;

    const eventProps = convertObjectValuesToTitleCase({
      experiment_name: ruleKey,
      variation_name: variationKey,
      feature_flag_name: flagName,
    });

    trackEvent('Experiment Viewed', { ...eventProps, ...pageConfig });
  }, [flagName, ruleKey, variationKey]);

  return null;
};
